import React, { createContext, useContext } from 'react'
import { BrandConfig, getBrandForHost } from './brandConfig'

const defaultBrand = getBrandForHost(window.location.hostname)

const BrandContext = createContext<BrandConfig>(defaultBrand)

export const BrandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const brand = getBrandForHost(window.location.hostname)
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
}

export const useBrand = (): BrandConfig => useContext(BrandContext)


